import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRemoveBackground2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="remove-background-2"><path fillRule="evenodd" clipRule="evenodd" d="M12 1C12.4142 1 12.75 1.33579 12.75 1.75V3H20.25L20.3271 3.00391C20.7051 3.04253 21 3.36183 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H12.75V22.25C12.75 22.6642 12.4142 23 12 23C11.5858 23 11.25 22.6642 11.25 22.25V21H3.75C3.33579 21 3 20.6642 3 20.25V3.75L3.00391 3.67285C3.04253 3.29488 3.36183 3 3.75 3H11.25V1.75C11.25 1.33579 11.5858 1 12 1ZM8 8H4.5V12H8V16H4.5V19.5H8V16H11.25V12H8V8H11.25V4.5H8V8Z" fill="currentColor"/></CentralIconBase>;
};

export default IconRemoveBackground2;
